<template>
  <div class="header-menu tw-z-100">
    <div class="top-menu">
      <div
        class="tw-w-full tw-hidden tw-h-16 tw-bg-white md:tw-flex tw-shadow-sm xl:tw-px-28 lg:tw-px-10 md:tw-px-10"
      >
        <div class="tw-h-16 tw-flex tw-flex-none tw-items-center">
          <a href="/">
            <img class="tw-h-10" src="@/static/staimg/tiansheng.png" alt />
          </a>
        </div>
        <div
          class="tw-flex tw-items-center tw-flex-1 tw-h-16 tw-justify-end xl:tw-gap-4 tw-gap-0.5"
        >
          <div class="tw-relative tw-w-64 md:tw-w-40 xl:tw-w-64 tw-h-16">
            <div
              class="tw-absolute tw-right-0 tw-top-1/2 tw-transform tw--translate-y-1/2 search-box"
              :class="{
                'tw-w-96 tw-z-10 tw-transition-all tw-duration-300 tw-ease-in-out ':
                  isBlur,
              }"
            >
              <div
                class="input-box tw-relative tw-flex tw-items-center tw-px-3 tw-py-1 tw-border tw-border-gray-300 tw-rounded-full tw-bg-white"
                :class="{ 'search-input': isBlur }"
                style="width: 100%"
              >
                <b-icon
                  icon="search"
                  class="tw-text-gray-400 tw-w-3.5 tw-h-3.5 tw-cursor-pointer"
                ></b-icon>
                <input
                  ref="searchInput"
                  maxlength="20"
                  class="tw-w-full tw-h-5 tw-ml-2"
                  v-model="searchValue"
                  type="text"
                  autocomplete="off"
                  size="sm"
                  @focus="handleFocus"
                  @input="handleInput"
                  @blur="handleBlur"
                  @keydown.enter.prevent
                  :placeholder="$t('请输入')"
                  style="font-size: 14px"
                />
              </div>
              <div
                class="tw-absolute tw-rounded-lg tw-w-full tw-flex tw-flex-col tw-mt-1 tw-bg-white tw-p-5 tw-shadow"
                style="min-height: 70px"
                v-if="isBlur && searchValue"
              >
                <div class="tw-flex tw-flex-col tw-gap-2">
                  <span class="tw-text-sm tw-text-textDisabled">{{
                    $t("项目")
                  }}</span>
                  <!-- 显示搜索结果 -->
                  <div
                    v-for="item in filteredList"
                    :key="item.id"
                    class="search-item tw-text-sm tw-py-3 tw-flex tw-items-center tw-justify-between tw-px-2 tw-rounded tw-cursor-pointer"
                    @mousedown.stop="handleItemClick(item)"
                  >
                    <div class="tw-flex tw-items-center tw-gap-2">
                      <img
                        :src="item.logo"
                        alt=""
                        class="tw-w-5 tw-h-5"
                        style="border-radius: 50%"
                        v-if="item.logo"
                      />
                      <span
                        class="tw-text-sm tw-w-44 fontstylewrapmore-1 tw-text-textMain tw-font-medium"
                        >{{ item.projectName }}</span
                      >
                    </div>
                    <div class="tw-flex tw-items-center tw-gap-1">
                      <span
                        class="tw-text-white tw-text-sm tw-font-medium tw-py-0.5 tw-px-2 tw-rounded"
                        style="background-color: #799f46"
                        >{{ item.creditScore }}</span
                      >
                      <span
                        class="tw-text-sm tw-font-medium tw-w-14 tw-text-center tw-py-0.5 tw-rounded"
                        style="
                          background-color: rgba(121, 159, 70, 0.1);
                          color: #799f46;
                        "
                        >{{ item.grade }}</span
                      >
                    </div>
                  </div>

                  <!-- 显示更多结果 -->
                  <div
                    v-if="filteredList.length > 5"
                    class="tw-text-xs tw-text-gray-500 tw-cursor-pointer tw-px-2 tw-py-0.5"
                    @click="handleShowMore"
                  >
                    显示更多结果（{{ filteredList.length }}）
                  </div>
                </div>
              </div>
            </div>
          </div>
          <b-dropdown
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
          >
            <template #button-content>
              <div
                class="d-flex align-items-center"
                style="cursor: pointer; color: #333"
              >
                <b-icon
                  icon="globe2"
                  style="width: 12px; height: 12px"
                ></b-icon>
                <span style="margin-left: 4px; font-size: 14px">
                  {{ sleLang === "zh-CN" ? "简体中文" : "English" }}
                </span>
              </div>
            </template>
            <b-dropdown-item href="#" @click="getSel('zh-CN')"
              >简体中文</b-dropdown-item
            >
            <b-dropdown-item href="#" @click="getSel('en')"
              >English</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>

      <!-- 二级导航栏 -->
      <div
        class="tw-hidden md:tw-flex tw-items-center tw-h-12 tw-bg-white tw-border-t xl:tw-px-28 lg:tw-px-10 md:tw-px-10"
      >
        <span class="tw-text-textMain tw-font-semibold tw-mr-8">{{
          $t("审计开发报告")
        }}</span>
        <div class="tw-flex tw-items-center tw-gap-6">
          <span
            class="tw-text-sm tw-cursor-pointer tw-font-semibold tw-py-1 tw-px-2"
            :class="
              activeNav === 'home'
                ? 'tw-text-primary tw-border-b-2 tw-border-primary'
                : 'tw-text-textInfo'
            "
            @click="handleNavClick('home')"
            >{{ $t("首页") }}</span
          >
          <span
            class="tw-text-sm tw-cursor-pointer tw-font-semibold tw-py-1 tw-px-2"
            :class="
              activeNav === 'all'
                ? 'tw-text-primary tw-border-b-2 tw-border-primary'
                : 'tw-text-textInfo'
            "
            @click="handleNavClick('all')"
            >{{ $t("全部报告") }}</span
          >
        </div>
      </div>

      <!-- 移动端头部  -->
      <div
        class="mobile tw-flex md:tw-hidden tw-h-16 tw-bg-white tw-items-center tw-justify-between tw-px-4"
      >
        <a href="/">
          <img class="tw-h-10" src="@/static/staimg/tiansheng.png" alt />
        </a>
        <div class="tw-flex tw-items-center">
          <b-icon
            class="tw-w-5 tw-h-5 tw-cursor-pointer"
            icon="search"
            @click="handleClickSearch"
            style="width: 18px; height: 18px; color: #333"
          ></b-icon>
          <div
            class="tw-ml-5 tw-flex tw-items-center tw-cursor-pointer tw-flex-none user-header"
          ></div>
        </div>
      </div>

      <!-- 移动端二级导航 -->
      <div
        class="tw-flex md:tw-hidden tw-items-center tw-h-10 tw-bg-white tw-border-t tw-px-4"
      >
        <span class="tw-text-textMain tw-text-sm tw-font-semibold tw-mr-4">{{
          $t("审计开发报告")
        }}</span>
        <div class="tw-flex tw-items-center tw-gap-4">
          <span
            class="tw-text-sm tw-cursor-pointer tw-font-semibold tw-py-1"
            :class="
              activeNav === 'home'
                ? 'tw-text-primary tw-border-b-2 tw-border-primary'
                : 'tw-text-textInfo'
            "
            @click="handleNavClick('home')"
            >{{ $t("首页") }}</span
          >
          <span
            class="tw-text-sm tw-cursor-pointer tw-font-semibold tw-py-1"
            :class="
              activeNav === 'all'
                ? 'tw-text-primary tw-border-b-2 tw-border-primary'
                : 'tw-text-textInfo'
            "
            @click="handleNavClick('all')"
            >{{ $t("全部报告") }}</span
          >
        </div>
      </div>
    </div>
    <b-sidebar
      sidebar-class="sidebar-menu"
      v-model="openSearch"
      no-header
      width="100%"
    >
      <MobileSearch @onSearch="getEnter" @onCloseSearch="openSearch = false" />
    </b-sidebar>
  </div>
</template>
<script>
import { mapState } from "vuex";
import BaseLayout from "../BaseLayout.vue";
import TopSearch from "./TopSearch.vue";
import UserInfo from "./UserInfo.vue";
import MobileSearch from "./MobileSearch.vue";
import { getAuditReportList } from "@/api/auditReport/index.js";

export default {
  components: {
    BaseLayout,
    TopSearch,
    UserInfo,
    MobileSearch,
  },
  data() {
    return {
      // 默认语言
      sleLang: "zh-CN",
      userInfo: "",
      hoverTimer: null, // 添加定时器用于延迟隐藏
      openMenu: false,
      openSearch: false,
      mobileMenuSelect: {},
      searchValue: "",
      isBlur: false,
      searchList: [],
      activeNav: "home",
    };
  },
  watch: {
    openSearch(newVal) {
      if (newVal) {
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
      }
    },
    $route: {
      handler(route) {
        if (route.path.includes("audit-all")) {
          this.activeNav = "all";
        } else {
          this.activeNav = "home";
        }
      },
      immediate: true,
    },
  },
  computed: {
    isLang() {
      return this.$store.state.isLang !== "zh-CN" ? "en" : "zh-CN";
    },
    current() {
      return this.$store.state.isType;
    },
    isLan() {
      return this.$store.state.isCla;
    },
    // 当前路由名称
    routName() {
      return this.$route.name;
    },
    ...mapState(["isSearch"]),
  },
  beforeDestroy() {
    // 搜索
    if (this.routName !== "search") {
      this.$store.commit("SET_ISSEARCH", "");
    }
    // localStorage.removeItem("indexInfo");
  },
  created() {
    this.getLang();
    this.userInfo = localStorage.getItem("userInfo");
    this.userInfo = JSON.parse(this.userInfo);
    this.getData();
  },
  mounted() {},
  methods: {
    handleClickSearch() {
      this.openSearch = !this.openSearch;
      if (this.openSearch) {
        this.openMenu = false;
      }
    },

    // 获取语言
    getLang() {
      this.sleLang = this.$store.state.isLang;
    },
    // 切换语言
    getSel(lang) {
      this.sleLang = lang;
      this.$store.commit("SET_LANG", lang);
      this.$i18n.locale = lang;
      location.reload();
    },
    // 搜索框按回车触发
    getEnter(a) {},

    // 页面跳转
    handleClickRoute(routeName, id) {
      if (id === 96) {
        this.$router.push(`/product/${id}`);
        return;
      }
      if (
        this.$route.path === routeName ||
        typeof routeName !== "string" ||
        !routeName.includes("/")
      )
        return;
      this.showKey = 0;
      this.$router.push(routeName);
    },

    // 获取审计列表
    async getData() {
      const { code, data } = await getAuditReportList({
        pageIndex: 1,
        pageSize: 10,
      });
      if (code !== 0) return;
      this.searchList = data.list || [];
      this.filteredList = data.list || [];
    },

    filterResults() {
      const searchTerm = this.searchValue.toLowerCase();

      if (!searchTerm) {
        this.filteredList = this.searchList;
        return;
      }

      // 模糊搜索：匹配项目名称或代币名称
      this.filteredList = this.searchList.filter((item) => {
        const projectName = item.projectName?.toLowerCase() || "";
        const tokenName = item.tokenName?.toLowerCase() || "";
        return (
          projectName.includes(searchTerm) || tokenName.includes(searchTerm)
        );
      });
    },

    // 处理搜索框输入
    handleInput() {
      this.isBlur = true;
      this.filterResults();
    },

    // 处理搜索框聚焦
    handleFocus() {
      this.isBlur = true;
      this.filterResults();
    },

    // 处理搜索框失去焦点
    handleBlur() {
      setTimeout(() => {
        this.isBlur = false;
      }, 200);
    },

    // 处理搜索结果点击
    handleItemClick(item) {
      this.$router.push({
        path: `/auditReport/audit-detail/${item.id}`,
      });
      this.searchValue = "";
      this.isBlur = false;
    },

    // 处理显示更多结果
    handleShowMore() {
      console.log("显示更多结果");
    },

    // 导航点击
    handleNavClick(nav) {
      this.activeNav = nav;
      if (nav === "home") {
        this.$router.push("/auditReport");
      } else if (nav === "all") {
        this.$router.push("/auditReport/audit-all");
      }
    },
  },
};
</script>
<style scoped lang="scss">
// 固定在顶部
.top-menu {
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 100;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.03);
}

.search-item {
  border-bottom: 1px solid #e9e9e9;
}

.search-item:hover {
}

.search-box {
  ::v-deep .form-control:hover {
    border-color: #409eff;
  }
}
.search-input {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgb(0, 123, 255, 0.25);
}
.input-box:hover {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgb(0, 123, 255, 0.25);
}
</style>
